export const validationForm = function (field) {
  if (!field) return false;

  const regex =
    /^[a-zA-Z0-9._%+-]+@(?!gmail\.com|hotmail\.com|yahoo\.com|outlook\.com|aol\.com|icloud\.com|protonmail\.com|yandex\.com|mail\.com|zoho\.com)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const email = field.value.trim();
  const parent = field.parentElement;
  if (!regex.test(email)) {
    if (parent.querySelector('#email-error')) return;
    const newElement = document.createElement('p');
    field.classList.add('invalid-email');
    newElement.classList.add('my-2', 'px-2');
    newElement.setAttribute('style', 'color:red');
    newElement.setAttribute('id', 'email-error');
    newElement.textContent = 'Correo no válido. Favor de usar correo empresarial.';
    parent.appendChild(newElement);
    return false;
  }
  if (parent.querySelector('#email-error')) parent.querySelector('#email-error').remove();
  field.classList.remove('invalid-email');
  return true;
};
